<template>
  <div class="main" id="about">
    <!--  -->
    <div class="row">
      <div class="banner_about pc">
        <div class="about">
          <!-- <img src="../../static/images/about/banner.png" /> -->
          <!-- <img src="../../static/images/about/banner_new.png" /> -->
          <h1>工作坊</h1>
          <p v-if="global.config[global.area_id].base"><span>{{ global.config[global.area_id].base.groups }} </span>大分会场并行授课，<span>{{ global.config[global.area_id].base.days }} </span>天<span> {{ global.config[global.area_id].base.teachers }} </span>位讲师全程以工作坊培训式展开, 每位讲师长达3小时深度分享</p>
          <p v-else><span>5 </span>大分会场并行授课，<span>2 </span>天<span> 25 </span>位讲师全程以工作坊培训式展开, 每位讲师长达3小时深度分享</p>
        </div>
      </div>
      <div class="wap_banner_schedule mob">
        <div class="about">
          <div class="img">
            <img src="../../static/images/about/wap_banner.png" />
          </div>
          <div class="ri">
            <h5>MPD技术管理工作坊</h5>
            <p v-if="global.config[global.area_id].base">
              {{ global.config[global.area_id].base.groups }}大分会场并行授课，{{ global.config[global.area_id].base.days }}天{{ global.config[global.area_id].base.teachers }}位讲师<br />全程以工作坊培训式展开,<br />
              每位讲师长达3小时深度分享。
            </p>
            <p v-else>
              5大分会场并行授课，2天25位讲师<br />全程以工作坊培训式展开,<br />
              每位讲师长达3小时深度分享。
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="main1">
      <div class="main1z">
        <h1>什么是MPD工作坊？</h1>
        <p>
          MPD工作坊由若干个微型课程组成，是一个围绕岗位角色发展的实践课堂，类似于微格教学的一种新模式训练系统，限定为三小时的小型课程，它使学员和教练集中解决某一特定的主题研讨、学习。MPD工作坊按照软件研发中心的岗位职能划分，以产品经理、团队经理、架构师、开发经理、测试经理作为五个分会场命名，以促进角色的共鸣思考、深度探讨、相互交流。每个分会场选拔优秀的参与者来分享自己或所属团队的故事，鼓励改变、专业、探索的软件精神，以及找出解决对策的手法。
        </p>
        <img src="../../static/images/about/img_01.png" width="100%" class="pc" />
        <img src="../../static/images/about/img_01f.png" width="100%" class="mob" />
      </div>
    </div>
    <div class="main3">
      <div class="main3z">
        <h1>为什么参加</h1>
        <ul class="row pc pc_about">
          <li class="col-lg-6 col-md-5 col-sm-12 col-xs-12">
            <div class="le">
              <img src="../../static/images/about/ab_01.png" />
            </div>
            <div class="ri">
              <h2>教练全程深度指导</h2>
              <h2>Coach in-depth guidance</h2>
              <p>
                {{ global.config[global.area_id].base&&global.config[global.area_id].base.teachers||'25' }}位国内外知名软件研发企业一线带头人全程指导，深度解析企业研发过程中所遇到的问题
              </p>
            </div>
          </li>
          <li class="col-lg-6 col-md-5 col-sm-12 col-xs-12">
            <div class="le">
              <img src="../../static/images/about/ab_04.png" />
            </div>
            <div class="ri">
              <h2>3小时大时段学习</h2>
              <h2>3 hours time to study</h2>
              <p>
                每个话题3小时大时段学习，以核心内容解决核心问题，围绕核心主题与教练不断重构现有的研发流程。
              </p>
            </div>
          </li>
          <li class="col-lg-6 col-md-5 col-sm-12 col-xs-12">
            <div class="le">
              <img src="../../static/images/about/ab_02.png" />
            </div>
            <div class="ri">
              <h2>现场沙盘实战演练</h2>
              <h2>Sandplan practice on site</h2>
              <p>
                工作坊现场实战，动手实操，奉行理论与实践相结合，全方位演练，发现问题，解决问题。
              </p>
            </div>
          </li>
          <li class="col-lg-6 col-md-5 col-sm-12 col-xs-12">
            <div class="le">
              <img src="../../static/images/about/ab_05.png" />
            </div>
            <div class="ri">
              <h2>一线实践案例剖析</h2>
              <h2>Frontier case analysis</h2>
              <p>
                客座教练携一线实践案例与学员深度剖析，结合案例梳理并打破研发过程中发生的种种窘境
              </p>
            </div>
          </li>
          <li class="col-lg-6 col-md-5 col-sm-12 col-xs-12">
            <div class="le">
              <img src="../../static/images/about/ab_03.png" />
            </div>
            <div class="ri">
              <h2>结对小组互动风暴</h2>
              <h2>Brainstorming group interaction</h2>
              <p>
                500位企业技术管理人员共同成长，多人小组共同探讨，研发问题头脑风暴，通过互动加强沟通，模拟团队协作场景，解决现场实践案例。
              </p>
            </div>
          </li>
          <li class="col-lg-6 col-md-5 col-sm-12 col-xs-12">
            <div class="le">
              <img src="../../static/images/about/ab_06.png" />
            </div>
            <div class="ri">
              <h2>实操交付成果展现</h2>
              <h2>Practice delivery results show</h2>
              <p>
                工作坊结束后，所有实操所得成果共同展示，教练点评，全员共同探讨
              </p>
            </div>
          </li>
        </ul>
        <ul class="row mob mob_about">
          <li class="col-lg-6 col-md-5 col-sm-12 col-xs-12">
            <div class="le">
              <img src="../../static/images/about/ab_01.png" />
            </div>
            <div class="ri">
              <h2>教练全程深度指导</h2>
              <h2>Coach in-depth guidance</h2>
              <p>
                20位国内外知名软件研发企业一线带头人全程指导，深度解析企业研发过程中所遇到的问题
              </p>
            </div>
          </li>
          <li class="col-lg-6 col-md-5 col-sm-12 col-xs-12">
            <div class="le">
              <img src="../../static/images/about/ab_02.png" />
            </div>
            <div class="ri">
              <h2>3小时大时段学习</h2>
              <h2>3 hours time to study</h2>
              <p>
                每个话题3小时大时段学习，以核心内容解决核心问题，围绕核心主题与教练不断重构现有的研发流程。
              </p>
            </div>
          </li>
          <li class="col-lg-6 col-md-5 col-sm-12 col-xs-12">
            <div class="le">
              <img src="../../static/images/about/ab_03.png" />
            </div>
            <div class="ri">
              <h2>现场沙盘实战演练</h2>
              <h2>Sandplan practice on site</h2>
              <p>
                工作坊现场实战，动手实操，奉行理论与实践相结合，全方位演练，发现问题，解决问题。
              </p>
            </div>
          </li>
          <li class="col-lg-6 col-md-5 col-sm-12 col-xs-12">
            <div class="le">
              <img src="../../static/images/about/ab_04.png" />
            </div>
            <div class="ri">
              <h2>一线实践案例剖析</h2>
              <h2>Frontier case analysis</h2>
              <p>
                客座教练携一线实践案例与学员深度剖析，结合案例梳理并打破研发过程中发生的种种窘境
              </p>
            </div>
          </li>
          <li class="col-lg-6 col-md-5 col-sm-12 col-xs-12">
            <div class="le">
              <img src="../../static/images/about/ab_05.png" />
            </div>
            <div class="ri">
              <h2>结对小组互动风暴</h2>
              <h2>Brainstorming group interaction</h2>
              <p>
                500位企业技术管理人员共同成长，多人小组共同探讨，研发问题头脑风暴，通过互动加强沟通，模拟团队协作场景，解决现场实践案例。
              </p>
            </div>
          </li>
          <li class="col-lg-6 col-md-5 col-sm-12 col-xs-12">
            <div class="le">
              <img src="../../static/images/about/ab_06.png" />
            </div>
            <div class="ri">
              <h2>实操交付成果展现</h2>
              <h2>Practice delivery results show</h2>
              <p>
                工作坊结束后，所有实操所得成果共同展示，教练点评，全员共同探讨
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="main4 row">
      <div class="main4z pc">
        <h1>谁适合参加MPD工作坊</h1>
        <ul>
          <li>
            <img src="../../static/images/about/ab_001.png" width="100%" />
            <p>产品创新/体验设计</p>
            <p>适合部门</p>
            <p>
              产品管理部、战略规划部、<br />客户运维部、IT部，<br />带领产品化的领导责任人
            </p>
            <p>适合人员</p>
            <p>
              总经理、产品经理、<br />用户体验师、新产品负责人、<br />产品规划设计师、技术总监、<br />首席架构师……
            </p>
          </li>
          <li>
            <img src="../../static/images/about/ab_002.png" width="100%" />
            <p>团队管理/工程文化</p>
            <p>适合部门</p>
            <p>
              以部门或产品线为单元，<br />
              带领团队人员达成使命的<br />领导负责人
            </p>
            <p>适合人员</p>
            <p>
              人力资源经理、技术部门经理、<br />IT经理、绩效考核经理、组织发展经理、过程改进经理、<br />小组组长……
            </p>
          </li>
          <li>
            <img src="../../static/images/about/ab_003.png" width="100%" />
            <p>架构设计/技术战略</p>
            <p>适合部门</p>
            <p>
              IT部门、信息中心、互联网<br />战略发展部、软件公司运营发展部<br />等架构决策负责人
            </p>
            <p>适合人员</p>
            <p>
              系统设计架构师、软件开发设计<br />核心骨干、架构师设计师、<br />软件开发主管、IT经理、<br />新技术布道师……
            </p>
          </li>
          <li>
            <img src="../../static/images/about/ab_004.png" width="100%" />
            <p>工程实践/前沿趋势</p>
            <p>适合部门</p>
            <p>
              软件开发部、项目部、<br />设计部等，负责开发过程<br />推进的责任人
            </p>
            <p>适合人员</p>
            <p>
              核心代码设计骨干、<br />程序开发主管、项目经理、<br />敏捷经理、过程改进经理、<br />架构设计师……
            </p>
          </li>
          <li>
            <img src="../../static/images/about/ab_005.png" width="100%" />
            <p>测试管理/运维交付</p>
            <p>适合部门</p>
            <p>
              软件测试部、<br />软件测试开发部，运行全程质量<br />保证（QA）的负责人
            </p>
            <p>适合人员</p>
            <p>
              软件测试经理、软件流程<br />改进经理、产品/项目经理、<br />开发主管、IT经理、<br />外包交付经理……
            </p>
          </li>
        </ul>
      </div>
      <div class="wap_main4z mob">
        <h1>谁适合参加MPD工作坊</h1>
        <ul>
          <li>
            <img src="../../static/images/about/ab_001.png" width="100%" />
            <p>产品创新/体验设计</p>
            <p>适合部门</p>
            <p>
              产品管理部、战略规划部、客户运维部、IT部，<br />带领产品化的领导责任人
            </p>
            <p>适合人员</p>
            <p>
              总经理、产品经理、用户体验师、新产品负责人、<br />产品规划设计师、技术总监、首席架构师……
            </p>
          </li>
          <li>
            <img src="../../static/images/about/ab_002.png" width="100%" />
            <p>团队管理/工程文化</p>
            <p>适合部门</p>
            <p>以部门或产品线为单元，带领团队人员达成使命的<br />领导负责人</p>
            <p>适合人员</p>
            <p>
              人力资源经理、技术部门经理、IT经理、绩效考核<br />经理、组织发展经理、过程改进经理、小组组长……
            </p>
          </li>
          <li>
            <img src="../../static/images/about/ab_003.png" width="100%" />
            <p>架构设计/技术战略</p>
            <p>适合部门</p>
            <p>
              IT部门、信息中心、互联网战略发展部、软件公司<br />运营发展部等架构决策负责人
            </p>
            <p>适合人员</p>
            <p>
              系统设计架构师、软件开发设计核心骨干、架构师<br />设计师、软件开发主管、IT经理、新技术布道师……
            </p>
          </li>
          <li>
            <img src="../../static/images/about/ab_004.png" width="100%" />
            <p>工程实践/前沿趋势</p>
            <p>适合部门</p>
            <p>软件开发部、项目部、设计部等，负责开发过程<br />推进的责任人</p>
            <p>适合人员</p>
            <p>
              核心代码设计骨干、程序开发主管、项目经理、<br />敏捷经理、过程改进经理、架构设计师……
            </p>
          </li>
          <li>
            <img src="../../static/images/about/ab_005.png" width="100%" />
            <p>测试管理/运维交付</p>
            <p>适合部门</p>
            <p>
              软件测试部、软件测试开发部，运行全程质量<br />保证（QA）的负责人
            </p>
            <p>适合人员</p>
            <p>
              软件测试经理、软件流程改进经理、产品/项目经理、<br />开发主管、IT经理、外包交付经理……
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
/* eslint-disable space-before-function-paren */
import $ from 'jquery'

export default {
  name: 'About',
  computed: {
    thisYear() {
      return this.global.year
    }
  },
  created () {
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/About.vue